var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMoney = function SvgMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.47 8.165C16.73 6.333 15.169 4.5 12.086 4.5c-3.853 0-4.902 2.68-4.902 3.907 0 1.072.319 3.04 4.661 3.96 4.249.899 5.41 2.38 5.212 4.599-.155 1.729-1.91 3.665-4.937 3.527-3.344-.153-4.816-1.988-5.59-3.026M12 4V1.5M12 23.5V21"
  }))));
};
export default SvgMoney;